class EnvironmentSize {
    static create(params) {
        return new EnvironmentSize(params);
    }

    constructor({screenSize}) {
        this.screenSize = screenSize;
    }

    isSmallDesktopBrowser() {
        if (this.isSmallDesktopScreen()) {
            return false;
        }

        var viewport = document.querySelector('html'),
            hasNarrowViewport = viewport.clientWidth < 1180,
            hasShortViewport = viewport.clientHeight < 575,
            canIncreaseBrowserWidth = this.screenSize.width - window.outerWidth > 30,
            canIncreaseBrowserHeight = this.screenSize.height - window.outerHeight > 30,
            narrowAndCanBeWider = hasNarrowViewport && canIncreaseBrowserWidth,
            shortAndCanBeTaller = hasShortViewport && canIncreaseBrowserHeight;

        return narrowAndCanBeWider || shortAndCanBeTaller;
    }

    isSmallDesktopScreen() {
        return this.screenSize.width < 1200;
    }
}

export default EnvironmentSize;